
const InputShimmer = ({ className }: { className?: string }) => {
    return (
        <div className={`animate-pulse ${!className ? 'w-80' : 'w-full'} h-14 bg-gray-200 rounded-lg`}></div>
    );
}

export default InputShimmer;
